import { render, staticRenderFns } from "./fazp.vue?vue&type=template&id=12209c3f&scoped=true&"
import script from "./fazp.vue?vue&type=script&lang=js&"
export * from "./fazp.vue?vue&type=script&lang=js&"
import style0 from "./fazp.vue?vue&type=style&index=0&id=12209c3f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12209c3f",
  null
  
)

export default component.exports